import { ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

import { ButtonModule } from 'primeng/button';
import { LucideAngularModule } from 'lucide-angular';

import { GuidedOnboardingService } from '../../services/guided-onboarding.service';

/** Convite discreto de primeiro acesso: não bloqueia a Dashboard nem a navegação. */
@Component({
  selector: 'app-onboarding-welcome',
  standalone: true,
  imports: [ButtonModule, LucideAngularModule],
  templateUrl: './onboarding-welcome.component.html',
  styleUrl: './onboarding-welcome.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OnboardingWelcomeComponent {
  protected readonly onboarding = inject(GuidedOnboardingService);
  private readonly router = inject(Router);

  constructor() {
    const destroyRef = inject(DestroyRef);
    void this.onboarding.onNavigated(this.router.url);
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(destroyRef)
      )
      .subscribe((event) => void this.onboarding.onNavigated(event.urlAfterRedirects));
  }
}
